import axios from 'axios';

let http = axios.create({
  baseURL: 'http://upload.qiniup.com/',
  // withCredentials: true,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});

function apiAxios(method, url, params, response) {
  http({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
  }).then(function (res) {
    response(res.data);
  }).catch(function (err) {
    console.log('网络异常，请稍后再试');
    console.log('url: '+ url + '; params: ' + JSON.stringify(params));
    console.log('err: ' + err)
  })
}

export default {
  get: function (url, params, response) {
    return apiAxios('GET', url, params, response)
  },
  post: function (url, params, response) {
    return apiAxios('POST', url, params, response)
  },
  put: function (url, params, response) {
    return apiAxios('PUT', url, params, response)
  },
  delete: function (url, params, response) {
    return apiAxios('DELETE', url, params, response)
  }
}
